module.exports = "/images/Norway.png?4c443db4914f6226c04789743ee0d823";